import { useState } from "react";
import { Link } from "react-router-dom";
import { Tag, Loader2, X } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { validateDiscount } from "@/lib/api";

export const discountOf = (d, gross) => {
  if (!d) return 0;
  const raw = d.type === "percent" ? (gross * d.value) / 100 : d.value;
  return Math.round(Math.max(0, Math.min(raw, gross - 1)) * 100) / 100;
};

export const fmt = (n) => Number(n).toFixed(2).replace(".00", "");

export const DiscountField = ({ gross, discount, setDiscount }) => {
  const { tr } = useLang();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const apply = async () => {
    if (!code.trim()) return;
    setBusy(true); setErr("");
    try {
      const d = await validateDiscount(code.trim(), gross);
      setDiscount({ code: d.discount_code, type: d.type, value: d.value });
    } catch (e) { setErr(e?.response?.data?.detail || tr("Codice non valido", "Invalid code")); }
    finally { setBusy(false); }
  };
  if (discount) {
    return (
      <div data-testid="discount-applied" className="flex items-center gap-2 border border-[#10b981] bg-[#ecfdf5] px-3 h-11 text-sm">
        <Tag className="w-4 h-4 text-[#059669]" />
        <span className="font-mono font-medium">{discount.code}</span>
        <span className="text-[#047857]">{discount.type === "percent" ? `-${discount.value}%` : `-${fmt(discount.value)}`}</span>
        <button data-testid="discount-remove" onClick={() => { setDiscount(null); setCode(""); }} className="ml-auto text-[#5b6168] hover:text-[#E0262C]"><X className="w-4 h-4" /></button>
      </div>
    );
  }
  return (
    <div>
      <div className="flex">
        <input data-testid="discount-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder={tr("Hai un codice sconto?", "Have a discount code?")}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); apply(); } }}
          className="flex-1 h-11 border border-[#cfd6d9] bg-white px-3 text-sm font-mono uppercase outline-none focus:border-[#2B3036]" />
        <button data-testid="discount-apply" type="button" onClick={apply} disabled={busy || !code.trim()}
          className="h-11 px-4 bg-[#2B3036] text-white text-sm font-medium disabled:opacity-40 hover:bg-[#E0262C] transition-colors">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : tr("Applica", "Apply")}
        </button>
      </div>
      {err && <div data-testid="discount-error" className="text-xs text-[#E0262C] mt-1">{err}</div>}
    </div>
  );
};

export const TermsCheck = ({ checked, onChange, dark }) => {
  const { tr } = useLang();
  return (
  <label data-testid="terms-check-label" className={`flex items-start gap-3 text-sm cursor-pointer ${dark ? "text-[#c4c9ce]" : "text-[#2B3036]"}`}>
    <input data-testid="terms-checkbox" type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
      className="mt-0.5 w-4 h-4 accent-[#E0262C] flex-shrink-0" />
    <span>
      {tr("Accetto i ", "I accept the ")}<Link to="/termini-e-condizioni" target="_blank" data-testid="terms-link" className="text-[#E0262C] underline">{tr("Termini e Condizioni", "Terms and Conditions")}</Link>{tr(" e la ", " and the ")}
      <Link to="/privacy-policy" target="_blank" data-testid="privacy-link" className="text-[#E0262C] underline">Privacy Policy</Link>{tr(" di PIXAWEB Sagl.", " of PIXAWEB Sagl.")} <span className="text-[#E0262C]">*</span>
    </span>
  </label>
  );
};
